import { useEffect, useState } from "react";

export const LANDING_PAGE_SIZE = 4;

export function useLandingVisibleItems(items = [], pageSize = LANDING_PAGE_SIZE) {
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const total = items.length;

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [total, pageSize]);

  const visibleItems = items.slice(0, visibleCount);
  const hasMore = visibleCount < total;
  const canShowLess = visibleCount > pageSize;

  const showMore = () =>
    setVisibleCount((count) => Math.min(count + pageSize, total));
  const showLess = () => setVisibleCount(pageSize);

  return {
    visibleItems,
    hasMore,
    canShowLess,
    showMore,
    showLess,
    total,
  };
}
